import { ActionType } from '../infrastructure/actionTypes';
import { IBlank } from '../infrastructure/interfaces';

export default (list: IBlank[] = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_BLANKS_DONE:
      const { blanks } = action;
      return blanks
    case ActionType.TOGGLE_BLANK_PUBLISH_DONE:
        const { toggledBlank } = action;
        const toggledList = list.map((b) => {
          return (b.id == toggledBlank.id) ? toggledBlank : b
        });
        return toggledList
    case ActionType.CREATE_BLANK_DONE:
      const { newBlank } = action;
      return list.concat(newBlank);
    case ActionType.UPDATE_BLANK_DONE:
      const { updatedBlank } = action;
      const updatedList = list.map((b) => {
        return (b.id == updatedBlank.id) ? updatedBlank : b
      });
      return updatedList;
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/blankList.ts